const UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

/** O backend devolve bytes; a escala (base 1024) fica com o front. */
export function formatBytes(bytes: number, locale?: string): string {
    if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";

    const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
    const value = bytes / 1024 ** exponent;
    const formatted = new Intl.NumberFormat(locale, { maximumFractionDigits: exponent === 0 ? 0 : 1 }).format(value);
    return `${formatted} ${UNITS[exponent]}`;
}
